import { RefundType } from "../constants";

export const getReasonTextByType = (type: RefundType) => {
  switch (type) {
    case RefundType.OrderCancellation:
      return "Order has been cancelled";
    case RefundType.OrderReturn:
      return "Order has been returned";
    case RefundType.OrderEditing:
      return "Order has been updated";
    case RefundType.OrderFailure:
      return "Order has been failed";
  }
};
